<template>
  <div>
    <form v-if="!verified" @submit.prevent="onSubmit()">
      <fieldset>
        <div class="line">
          <label for="verify-email">Sähköposti:</label>
          <input v-model.trim="email" type="email" name="email" id="verify-email" autocomplete="email">
          <span v-if="wrongEmail" class="error">Tarkista sähköposti</span>
        </div>
        <div class="line">
          <label for="verify-code">Vahvistus koodi:</label>
          <input v-model.trim="code" type="text" name="code" id="verify-code">
          <span v-if="wrongCode" class="error">Tarkista koodi</span>
        </div>

        <p v-if="error" class="error">Jotain meni pieleen, yritä uudelleen.</p>
        <button type="submit">Vahvista</button>
      </fieldset>
    </form>
    <div v-if="verified">
      <p>Sahköpostisi on varmistettu.</p>
      <router-link :to="{name: 'LoginView', query: {email: email} }"><span>Kirjaudu sisään</span></router-link>
    </div>
  </div>
</template>

<script>

import { CognitoUserPool, AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import userpoolconfig from './../userpoolconfig'
import types from './../store/types'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'VerifyRegisterationView',
  data () {
    return {
      email: this.initEmail(),
      code: this.initCode(),
      status: 'initial',
    }
  },
  computed: {
    verified () {
      return this.status === 'verified'
    },
    error () {
      return this.status === 'error'
    },
    loading () {
      return this.status === 'loading'
    },
    wrongCode () {
      return this.status === 'wrongCode'
    },
    wrongEmail () {
      return this.status === 'wrongEmail'
    }
  },
  methods: {
    initEmail () {
      return this.$route.query.email || '';
    },
    initCode () {
      return this.$route.query.code || '';
    },
    onSubmit () {
      console.log('verify onSubmit');
      this.status = 'loading'
      const {email, code} = this;
      const username = email.replace('@', '-at-');
      this.authVerify({username, code})
        .then(() => {
          this.status = 'verified';
        })
        .catch((err) => {
          this.status = 'error';

          if (err.code === 'CodeMismatchException') {
            this.status = 'wrongCode'
          }

          if (err.code === 'UserNotFoundException') {
            this.status = 'wrongEmail'
          }
        })
    },
    ...mapActions('Auth', ['authRequest', 'authVerify']),
  },
  mounted () {
    if (this.email.length > 0 && this.code.length > 0) {
      this.onSubmit();
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'src/color.scss';

  form {
    text-align: left;
    width: 80%;
    margin: 1em auto;
  }

  fieldset {
    border: none;
  }

  input, label {
    box-sizing: border-box;
    cursor: pointer;
  }

  input {
    display: block;
    width: 100%;
    padding: 0.4em 0.3em;
    font-weight: bold;
  }

  .line {
    margin-bottom: 1em;
  }

  label {
    width: 100%;
    display: inline-block;
    margin-bottom: 0.4em;
    font-weight: bold;
  }

  button {
    padding: 0.6em 0.8em;
    border-radius: 0.5em;
    //background: linear-gradient($secondary-light, $secondary);
    background: $secondary;
    color: white;
    display: block;
    margin: 0 auto;
    font-size: 110%;
    font-weight: bold;
  }

  button:hover,
  button:active,
  button:focus {
    background: white;
    border: 2px solid $secondary;
    color: initial;
    outline: none;
  }

  .error {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/VerifyRegisterationView.vue